import React from 'react'

//styles
import "./Inventario.css"
import CreateNewProduct from '../../components/forms/CreateNewProduct/CreateNewProduct'
import ProductTable from '../../components/tablets/ProductTable'
import ProductListTable from '../../components/productListTable/ProductListTable'
import FilterBar from '../../components/FilterBar/FilterBar'
import { Button } from 'antd'
import { useNavigate } from 'react-router-dom'

const Inventario = () => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [filterCategory, setFilterCategory] = React.useState<string>("");
  const [filterFranchise, setFilterFranchise] = React.useState<string>("");
  const [filterStatus, setFilterStatus] = React.useState<string>("");
  const [filterName, setFilterName] = React.useState<string>("");
  const [total, setTotal] = React.useState<number>(0);
  
  const navigate = useNavigate();

  return (
    <div>
      <div className='Inventory-header'>
        <div className='Inventory-header-title'>
          {/* <span>
            Inventario
          </span>

          <span>Lorem ipsum dolor, sit amet consectetur adipisicing elit.</span> */}
        </div>

        <div>
          <Button type='primary' onClick={()=>{navigate("/crear-producto", { replace: true });}} >Crear Producto </Button>
        </div>

      </div>

      <FilterBar
      filterName={filterName}
      setFilterName={setFilterName}
      filterCategory={filterCategory}
      filterFranchises={filterFranchise}
      filterStatus={filterStatus}
      loadingProducts={loading}
      setFilterCategory={setFilterCategory}
      setFilterFranchises={setFilterFranchise}
      setFilterStatus={setFilterStatus} />

      <ProductListTable
       categories={filterCategory}
       franchise={filterFranchise}
       loading={loading}
       name={filterName}
       status={filterStatus}
       setLoading={setLoading}
      />
    </div>
  )
}

export default Inventario